import React, { Component, Fragment } from 'react';
import {
  SectionWrapper,
  BankAccountForm,
  UploadConfirm,
  BankAccountModal
} from '../../../views/Employee/FiscalData';

import {
  Section,
  TitleSection,
  TooltipElement,
  AccordionDataSection
} from '../../../views/Employee/FiscalData/IRPFData';

import { StatusMessage } from './common';

import {
  StyledAlignRight,
  StatusMessageWrapper,
  StyledTwoLevelBreadcrumb
} from './style';

import Loading from '../../../core/Loading';

import Button from '../../../core/Buttons';
import { bankAccount } from '../../../../constants/user';
import {
  getIbanFromChangeRequest,
  getBankDetails,
  createIbanChangeRequest,
  updateIbanChangeRequest,
  deleteIbanChangeRequest
} from '../../../../utils/apiFiscalData';

class BankAccountSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 'Resume',
      cancelling: false,
      pending: false,
      isLoading: true,
      validIbanCode: true,
      ibanCode: '',
      accountData: null,
      onErrorLoadData: false
    };
  }

  componentDidMount() {
    getIbanFromChangeRequest()
      .then(response => {
        this.setState({
          ibanCode: response,
          pending: true
        });
      })
      .catch(error => {
        if (error.code === 404) {
          this.setState({
            pending: false
          });
        }
        throw error;
      })
      .finally(() => {
        getBankDetails()
          .then(response => {
            const accountData = Object.entries(response).filter(
              item => item[0] !== 'employeeId'
            );
            const data = accountData.map(item => ({
              title: bankAccount.label[item[0]],
              body: item[1]
            }));

            const addressIndex = data.findIndex(
              item => item.title === 'Población'
            );

            data.splice(
              addressIndex,
              3,
              data[addressIndex + 2],
              data[addressIndex],
              data[addressIndex + 1]
            );

            this.setState({
              accountData: data
            });
          })
          .catch(error => {
            this.setState({
              onErrorLoadData: true
            });
            throw error;
          })
          .finally(() => {
            this.setState({
              isLoading: false
            });
          });
      });
  }

  ibanChangeRequest = ibanCode => {
    const { pending } = this.state;
    const service = !pending
      ? createIbanChangeRequest
      : updateIbanChangeRequest;

    this.setState({
      isLoading: true,
      ibanCode
    });

    service(ibanCode)
      .then(() => {
        this.setState({
          validIbanCode: true,
          pending: true,
          page: 'Confirm'
        });
      })
      .catch(error => {
        if (error.code === 400) {
          this.setState({
            validIbanCode: false
          });
        }
        throw error;
      })
      .finally(() => {
        this.setState({
          isLoading: false
        });
      });
  };

  cancelIbanChangeRequest = () => {
    this.setState({
      isLoading: true,
      cancelling: false
    });

    deleteIbanChangeRequest()
      .then(() => {
        this.setState({
          pending: false,
          page: 'Resume'
        });
      })
      .catch(error => {
        throw error;
      })
      .finally(() => {
        this.setState({
          isLoading: false
        });
      });
  };

  getRender = () => {
    const { cancel } = this.props;
    const {
      onErrorLoadData,
      page,
      pending,
      cancelling,
      accountData,
      validIbanCode,
      ibanCode
    } = this.state;

    if (onErrorLoadData) {
      return <p>Lo sentimos, pero no existen datos para su usuario</p>;
    }

    return (
      <SectionWrapper>
        {page === 'Resume' && (
          <Fragment>
            {pending && (
              <StatusMessageWrapper>
                <StatusMessage
                  text={bankAccount.bankAccountPending}
                  onEdit={() =>
                    this.setState({
                      page: 'Edit'
                    })
                  }
                  onDelete={() =>
                    this.setState({
                      cancelling: true
                    })
                  }
                />
              </StatusMessageWrapper>
            )}
            <Section>
              <TitleSection>
                <TooltipElement text={bankAccount.bankAccountResume.title} />
              </TitleSection>
              {accountData.map(
                item =>
                  item && (
                    <AccordionDataSection
                      title={item.title}
                      body={item.body}
                      span={0}
                    />
                  )
              )}
            </Section>
            <StyledAlignRight>
              <Button
                secondary
                fixed
                onClick={() => cancel()}
                disabled={pending}
              >
                {bankAccount.bankAccountBackBtn}
              </Button>
              <Button
                secondary
                fixed
                onClick={() => this.setState({ page: 'Edit' })}
                disabled={pending}
              >
                {bankAccount.bankAccountBtn}
              </Button>
            </StyledAlignRight>
          </Fragment>
        )}
        {page === 'Edit' && (
          <Fragment>
            <StyledTwoLevelBreadcrumb
              first={bankAccount.bankAccountBreadcrumb.first}
              second={bankAccount.bankAccountBreadcrumb.second}
              onBack={() => {
                this.setState({
                  page: 'Resume'
                });
              }}
            />
            <BankAccountForm
              onSend={ibanCodeSelected =>
                this.ibanChangeRequest(ibanCodeSelected)
              }
              onBack={() => {
                this.setState({
                  page: 'Resume'
                });
              }}
              validIbanCode={validIbanCode}
              ibanCode={ibanCode}
            />
          </Fragment>
        )}
        {page === 'Confirm' && (
          <UploadConfirm
            onClick={() => this.setState({ page: 'Resume', pending: true })}
            title={bankAccount.bankAccountConfirm.title}
            txt={bankAccount.bankAccountConfirm.txt}
          />
        )}
        {cancelling && (
          <BankAccountModal
            onCancel={() =>
              this.setState({
                cancelling: false
              })
            }
            onAccept={() => {
              this.cancelIbanChangeRequest();
            }}
          />
        )}
      </SectionWrapper>
    );
  };

  render() {
    const { isLoading } = this.state;

    return isLoading ? <Loading /> : this.getRender();
  }
}

export default BankAccountSection;
